import { render, staticRenderFns } from "./BtnInserirFeriados.vue?vue&type=template&id=28390f84"
import script from "./BtnInserirFeriados.vue?vue&type=script&lang=js"
export * from "./BtnInserirFeriados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports